	var currentBgColor,
		targetBgColor,
		targetTxColor,
		colorThreshold = 0.5,
		isFirstPass = true;

$(function(){
	if($('[data-bg-color]').length){
		body.on('scrolld',function(){
			updateColor();
		});
		body.trigger('scrolld')
		updateColor();
	}
});

function updateColor(){
	$('[data-bg-color]').each(function(){
		var bgColor = $(this).attr('data-bg-color'),
			txColor = $(this).attr('data-tx-color');
		if(bgColor.length > 2 && $(this).offset().top < scrolld + colorThreshold * winH){
			targetBgColor = bgColor;
			targetTxColor = txColor;
			$(this).addClass('page-active').siblings().removeClass('page-active');
			updateNav($(this));
		}
	});
	if(currentBgColor != targetBgColor){
		body.css({
			'background-color':targetBgColor,
			'color':targetTxColor
		});
		// setTimeout(function(){
			currentBgColor = targetBgColor;
		// },5);
	}
	// var colorPhaser;
	// if(scrolld < colorThreshold * winH){
	// 	var currentColor = window.getComputedStyle(document.body).getPropertyValue('color'),
	// 		currentRGB = currentColor.split('(')[1].split(')')[0].split(','),
	// 		currentHSL = rgbToHsl(currentRGB[0],currentRGB[1],currentRGB[2]);
	// 	var hue = currentHSL[0];
	// 	if(isFirstPass){
	// 		satLum = ','+currentHSL[1].toFixed(2)+'%,'+currentHSL[2].toFixed(2)+'%)';
	// 		isFirstPass = false;
	// 	}
	// 	colorPhaser = setInterval(function(){
	// 		hue += 10;
	// 		if(hue > 360){
	// 			hue = 360 - hue;
	// 		}				
	// 		body.css('color','hsl(' + hue + satLum );
	// 	},660);
	// } else{
	// 	clearInterval(colorPhaser);
	// }
}

function rgbToHsl(r, g, b) {
  r /= 255, g /= 255, b /= 255;

  var max = Math.max(r, g, b), min = Math.min(r, g, b);
  var h, s, l = (max + min) / 2;

  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }

    h /= 6;
  }

  return [ h, s, l ];
}
